// common

// user
export const GET_USER = 'GET_USER'
export const SET_USER = 'SET_USER'

// stat
export const UPDATE_STAT_INFO = 'UPDATE_STAT_DATA'
export const ADD_STAT = 'ADD_STAT'
export const SET_STAT = 'SET_STAT'
export const ADD_OBSERVER = 'ADD_OBSERVER'
export const UPDATE_OBSERVER = 'UPDATE_OBSERVER'
export const CLEAR_OBSERVER = 'CLEAR_OBSERVER'
export const DO_STAT = 'CLEAR_OBSERVER'
